// extracted by mini-css-extract-plugin
export default {"contentBox":"TagItemLine_contentBox__RNJmZ","tagName":"TagItemLine_tagName__X+-KP"};